var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.$mq},[_c('CurrencyAmount',{attrs:{"amount":_vm.high_limit}}),_vm._v(" /\n  "),_c('CurrencyAmount',{attrs:{"amount":_vm.low_limit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }